var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDocument = function SvgDocument(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 18 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#25314C",
    d: "M14 .25H4C1.582.25.25 1.582.25 4v12c0 2.418 1.332 3.75 3.75 3.75h10c2.418 0 3.75-1.332 3.75-3.75V4c0-2.418-1.332-3.75-3.75-3.75M16.25 16c0 1.577-.673 2.25-2.25 2.25H4c-1.577 0-2.25-.673-2.25-2.25V4c0-1.577.673-2.25 2.25-2.25h10c1.577 0 2.25.673 2.25 2.25zM5.75 6a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m0 4a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m0 4a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m8-8a.75.75 0 0 1-.75.75H8a.75.75 0 0 1 0-1.5h5a.75.75 0 0 1 .75.75m0 4a.75.75 0 0 1-.75.75H8a.75.75 0 0 1 0-1.5h5a.75.75 0 0 1 .75.75m0 4a.75.75 0 0 1-.75.75H8a.75.75 0 0 1 0-1.5h5a.75.75 0 0 1 .75.75"
  })));
};
export default SvgDocument;